const createArray = (start: number, end: number) => {
  return Array.from({ length: end - start + 1 }).map((_, i) => i + start);
};

const getDelta = (current: number, count: number) => {
  if (count <= 7) {
    // delta = 7: [1 2 3 4 5 6 7]
    return 7;
  } else {
    // delta = 2: [1 . 4 5 6 . 8]
    // delta = 4: [1 2 3 4 5 . 8]
    return current > 4 && current < count - 3 ? 2 : 4;
  }
};

const getRange = (current: number, count: number, delta: number) => {
  let start = Math.round(current - delta / 2);
  let end = Math.round(current + delta / 2);

  if (start - 1 === 1 || end + 1 === count) {
    start += 1;
    end += 1;
  }

  return { start, end };
};

type Pages = (number | "...")[];

const createPages = (current: number, count: number): Pages => {
  const delta = getDelta(current, count);
  const range = getRange(current, count, delta);
  let pages = [];

  if (current > delta) {
    pages = createArray(
      Math.min(range.start, count - delta),
      Math.min(range.end, count)
    );
  } else {
    pages = createArray(1, Math.min(count, delta + 1));
  }

  const withDots = (value: number, current: Pages) => {
    return pages.length + 1 !== count ? current : [value];
  };

  if (pages[0] !== 1) {
    pages = withDots(1, [1, "..."]).concat(pages);
  }

  if (pages[pages.length - 1] < count) {
    pages = pages.concat(withDots(count, ["...", count]));
  }

  return pages;
};

export default createPages;
